const FGVFontName = {
  fontFamily: 'Montserrat',
  htmlFontSize: 16,
  fontWeightRegular: 400,
  fontWeightBold: 600,

  h1: headingStyle('2.5rem'),
  h2: headingStyle('2rem'),
  h3: headingStyle('1.75rem'),
  h4: headingStyle('1.5rem'),
  h5: headingStyle('1.25rem'),
  h6: headingStyle('1.125rem'),
  body1: bodyStyle('1rem'),
  body2: bodyStyle('0.875rem'),
};

function headingStyle(fontSize) {
  return {
    fontWeight: 600,
    fontSize,
    letterSpacing: '-0.25px',
    lineHeight: '130%',
  };
}

function bodyStyle(fontSize) {
  return {
    fontWeight: 400,
    fontSize,
    letterSpacing: '0.25px',
    lineHeight: '160%',
  };
}

export default FGVFontName;
